// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 12) return "static/js/e5d250e09616f487db47.bundle.js";
	if (chunkId === 3) return "static/js/fb115b71f9415a9d975c.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"0184b6f7158575166e66","139":"640f5f0673a183d8d641","140":"e32d1e21a18f94a9b575"}[chunkId] + ".chunk.js";
};